import css from 'styled-jsx/css';

export default css`:global(body) {
  background-color: #ffffff; }
`